import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Material } from '../material';
import { RabattStaffelService } from './rabatt-staffel.service';

export class ArtikelRabattstaffel {
    ar_id: number;
    artikel_id: number;
    artikel_me: string;
    artikelmenge_ab: number;
    rabatt: number;
}

export interface ArtikelRabattstaffelApi {
    records: ArtikelRabattstaffel[];
    count: number;
}

@Component({
    selector: 'kiene-rabatt-staffel',
    templateUrl: './rabatt-staffel.component.html',
    styleUrls: ['./rabatt-staffel.component.scss'],
})
export class RabattStaffelComponent implements OnInit, OnChanges {
    @Input('material') material: Material;

    rabattstaffeln: ArtikelRabattstaffel[] = [];

    rabattCtrl = new UntypedFormControl();
    amountCtrl = new UntypedFormControl();

    constructor(
        private readonly api: RabattStaffelService,
        private readonly message: MessageService,
        private readonly localStorageService: LocalStorageService,
    ) {}

    ngOnInit() {
        if (this.material.artikel_id && this.localStorageService.currentUserHasPermission(3411)) {
            this.loadRabattstaffeln();
        }
    }

    ngOnChanges() {
        if (this.material.artikel_id && this.localStorageService.currentUserHasPermission(3411)) {
            this.loadRabattstaffeln();
        }
    }

    loadRabattstaffeln() {
        if (!this.localStorageService.currentUserHasPermission(3411)) {
            return;
        }
        this.api.getRabattStaffeln(this.material.artikel_id.toString()).subscribe(response => {
            this.rabattstaffeln = response.records;
        });
    }

    remove(rs: ArtikelRabattstaffel) {
        this.api.remove(rs).subscribe(
            () => {
                this.loadRabattstaffeln();
            },
            error => {
                this.message.errorMessage('Die Rabattstaffel konnte nicht entfernt werden: ', error);
            },
        );
    }

    save() {
        const rs = new ArtikelRabattstaffel();
        rs.artikelmenge_ab = this.amountCtrl.value;
        rs.rabatt = this.rabattCtrl.value;
        rs.artikel_id = this.material.artikel_id;
        this.api.save(rs).subscribe(
            () => {
                this.loadRabattstaffeln();
            },
            error => {
                this.message.errorMessage('Rabattstaffel konnte nicht hinzugefügt werden! ', error);
            },
        );
    }
}
